import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { postLogoutRequest } from '../../redux/actions/authentication';
import { LOAD_APP_CONTEXT } from '../../redux/actions/cm/app';

import { updateUserId } from '../../redux/actions/cm/context';
import {
  fetchUserList,
  fetchUserListFail,
  fetchUserListSuccess
} from '../../redux/actions/cm/users';
import {
  fetchDepartments as fetchDepartmentsAction,
  fetchDepartmentsSuccess,
  fetchDepartmentsFail
} from '../../redux/actions/cm/departments';
import {
  fetchAlertLevel,
  fetchWorkFlowStatusList
} from '../../redux/actions/cm/workFlowStatus';

import { fetchUsers, fetchCurrentUser } from '../../services/cm/users';
import { fetchDepartments } from '../../services/cm/departments';
import { hasResource } from '../../util';
import { cmResources } from '../../util/GlobalConstant';
import { fetchDashboardBins } from '../../redux/actions/cm/dashboard';

function* loadAppContextWorker() {
  const authData = yield select(({ authentication }) => authentication);
  const policies = authData?.data;
  const hasOthersDepartmentsAccess = hasResource(
    policies,
    cmResources.APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS
  );

  yield put(fetchUserList());
  yield put(fetchDepartmentsAction());
  yield put(fetchAlertLevel());
  yield put(fetchWorkFlowStatusList());
  yield put(fetchDashboardBins());

  // Fetch current user info
  let currentUser = null;
  try {
    currentUser = yield call(fetchCurrentUser);
    yield put(updateUserId(currentUser.user.id));
  } catch (error) {
    yield put(
      postLogoutRequest({
        token: localStorage.getItem('id_token')
      })
    );
  }

  // Fetch and check access for user list
  let users = [];
  try {
    const response = yield call(fetchUsers);
    users = response.users;
  } catch (error) {
    yield put(fetchUserListFail());
  }

  const currentUserDepartmentIds = (currentUser?.departments || []).map(
    ({ id }) => id
  );

  yield put(fetchUserListSuccess(users));

  // Fetch and check access for departments
  let departments = [];
  try {
    departments = yield call(fetchDepartments) || [];
  } catch (error) {
    yield put(fetchDepartmentsFail());
  }

  const accessibleDepartments = hasOthersDepartmentsAccess
    ? departments
    : departments.filter(({ id }) => currentUserDepartmentIds.includes(id));
  yield put(fetchDepartmentsSuccess(accessibleDepartments));
}

export function* watchLoadAppContext() {
  yield takeEvery(LOAD_APP_CONTEXT, function* () {
    yield fork(loadAppContextWorker);
  });
}
